import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import App from '../App.vue';
import router from '../router';
import store from '../store';
import i18n from '../i18n';
import { ApiBaseUrl } from "@/constants";


Vue.use(Vuetify);

import pt from 'vuetify/src/locale/pt.ts'
import es from 'vuetify/src/locale/es.ts'
import Axios from 'axios';

const DEFAULT_LOGO_SRC = "/imagens/merustracker-white.png";
const DEFAULT_THEME_LIGHT = {
  primary: "#1976D2",
  secondary: "#424242",
  accent: "#82B1FF",
  error: "#FF5252",
  info: "#2196F3",
  success: "#4CAF50",
  warning: "#FFC107",
  header: "#1976D2",
  menuBackground: "#1976D2",
};

export const renderApp = async () => {
  const [resTema, resLogo] = await Promise.all([
    Axios.get(ApiBaseUrl + "/api/v1.0/tema").catch((error) => {
      console.warn("Falha ao carregar tema ativo; usando tema padrão.", error);
      return null;
    }),
    Axios.get(ApiBaseUrl + "/api/v1.0/getlogoativa").catch((error) => {
      console.warn("Falha ao carregar logo ativo; usando logo padrão.", error);
      return null;
    }),
  ]);

  const logo = resLogo && resLogo.data && resLogo.data[0] && resLogo.data[0].src
    ? resLogo.data[0].src
    : DEFAULT_LOGO_SRC;
  sessionStorage.setItem("logo", logo);

  try {
    const resModo = await Axios.get(ApiBaseUrl + "/api/v1.0/getidmodo");
    const idModo = resModo.data && resModo.data[0] ? resModo.data[0].id_modo : 2;
    sessionStorage.setItem("setup_id_modo", idModo);
  } catch (e) {
    sessionStorage.setItem("setup_id_modo", 2);
  }

  const themeLight = resTema && resTema.data && resTema.data[0] && resTema.data[0].tema
    ? JSON.parse(resTema.data[0].tema)
    : DEFAULT_THEME_LIGHT;
  
  // Remove buttonText from theme as it's a CSS class, not a color value
  const { buttonText, ...themeColors } = themeLight;
  
  // Store buttonText separately if it exists (it's a CSS class, not a color)
  if (buttonText) {
    sessionStorage.setItem("buttonTextClass", buttonText);
  }

  const vuetify = new Vuetify({
    lang: {
      locales: { pt, es },
      current: 'pt',
    },
    theme: {
      themes: {
        light: themeColors,
      },
    }
  });

  const app = new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
  });

  const vm = app.$mount('#app');

  if (typeof window !== 'undefined') {
    window.$root = app;
    window.dispatchEvent(new Event('merustracker:app-ready'));
  }

  return vm;
};
